<template>
  <nav class="navbar navbar-expand-lg bg-white">
    <div class="container-fluid">
      <AppLogo/>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
              data-bs-target="#navbarToggle"
              aria-controls="navbarToggle" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarToggle">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <AppMenuItems/>
        </ul>
      </div>
    </div>
  </nav>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h1 v-if="bookingType=='room'" class="text-center poppinsBold p-3">{{ $t("find.headerRoom") }}</h1>
        <p v-if="bookingType=='room'" class="text-center p-3" v-html="$t('find.subHeaderRoom')"></p>
        <h1 v-if="bookingType=='apartment'" class="text-center poppinsBold p-3">{{ $t("find.headerApartment") }}</h1>
        <p v-if="bookingType=='apartment'" class="text-center p-3" v-html="$t('find.subHeaderApartment')"></p>
      </div>
    </div>
    <div class="m-3 pt-2 pb-2 ps-4 pe-3 searchForm collapse" id="collapseSearch">
      <form @submit.prevent="submitSearchForm">
        <div class="row g-3">
          <div class="col-md-2">
            <div class="input-group">
                            <span class="input-group-text input-group-text-mod">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                     class="bi bi-calendar3" viewBox="0 0 16 16">
                                <path
                                    d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z"/>
                                <path
                                    d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                            </svg>
                            </span>
              <div class="form-floating">
                <input type="date" class="form-control form-control-mod" id="check-in-date"
                       v-model="checkInDate" :min="minCheckIn" @input="updateMax">
                <label for="check-in-date">{{ $t('checkIn') }}</label>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="input-group">
                            <span class="input-group-text input-group-text-mod">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                     class="bi bi-calendar3" viewBox="0 0 16 16">
                                <path
                                    d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z"/>
                                <path
                                    d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                            </svg>
                            </span>
              <div class="form-floating">
                <input type="date" class="form-control form-control-mod" id="check-out-date"
                       v-model="checkOutDate" :min="minCheckOut">
                <label for="check-out-date">{{ $t('checkOut') }}</label>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="input-group">
                            <span class="input-group-text input-group-text-mod">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                     class="bi bi-pin-map" viewBox="0 0 16 16">
                                  <path fill-rule="evenodd"
                                        d="M3.1 11.2a.5.5 0 0 1 .4-.2H6a.5.5 0 0 1 0 1H3.75L1.5 15h13l-2.25-3H10a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .4.2l3 4a.5.5 0 0 1-.4.8H.5a.5.5 0 0 1-.4-.8l3-4z"/>
                                  <path fill-rule="evenodd"
                                        d="M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999z"/>
                                </svg>
                            </span>
              <div class="form-floating">
                <select id="city" class="form-select form-select-mod" v-model="selectedCity" required>
                  <option value="León" selected>León</option>
                </select>
                <label for="city">{{ $t('city') }}</label>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="input-group">
                            <span class="input-group-text input-group-text-mod">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                     class="bi bi-house-heart" viewBox="0 0 16 16">
                                  <path d="M8 6.982C9.664 5.309 13.825 8.236 8 12 2.175 8.236 6.336 5.309 8 6.982Z"/>
                                  <path
                                      d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.707L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.646a.5.5 0 0 0 .708-.707L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z"/>
                                </svg>
                            </span>
              <div class="form-floating">
                <select id="booking-type" class="form-select form-select-mod" v-model="bookingType">
                  <option value="room">{{ $t('roomCap') }}</option>
                  <option value="apartment">{{ $t('apartment') }}</option>
                </select>
                <label for="booking-type">{{ $t('rentalType') }}</label>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="input-group">
                            <span class="input-group-text input-group-text-mod">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                                     class="bi bi-people" viewBox="0 0 16 16">
                                  <path
                                      d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8Zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022ZM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816ZM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"/>
                                </svg>
                            </span>
              <div class="form-floating">
                <select id="num-of-people" class="form-select form-select-mod" v-model="numOfPeople"
                        required>
                  <option value="1" rel="1" selected>1</option>
                  <option value="2" rel="2">2</option>
                  <option value="3" rel="3">3</option>
                  <option value="4" rel="4">4</option>
                  <option value="5" rel="5">5</option>
                  <option value="6" rel="6">6</option>
                  <option value="7" rel="7">7+</option>
                </select>
                <label for="num-of-people">{{ $t('numPeople') }}</label>
              </div>
            </div>
          </div>
          <div class="col-md-2 d-flex justify-content-end align-items-end">
            <button id="btnBook" class="btn btn-primary form-control" type="submit">{{ $t('search') }}
            </button>
          </div>
        </div>
      </form>
    </div>
    <div v-if="!isSmallScreen" id="resultsSearch" class="row g-3"
         style="display: none; margin: 0">
      <div class="col-md-6 mt-0 pt-4">
        <div class="row" id="result">
          <div class="col-4 ms-3 mb-3 p-1 space" v-for="(p, index) in properties"
               :key="p.id" @mouseover="mouseOverMap(p._id)" @mouseout="mouseOutMap(p._id)">
            <div :id="'carouselIndicators' + index" class="carousel slide mb-2" data-ride="carousel">
              <div class="carousel-inner">
                <div :class="['carousel-item', { active: index === 0 }]"
                     v-for="(picture, index) in p.pictures" v-bind:key="index">
                  <small class="floatingNotice" v-if="p.tag"><span v-if="es">{{ p.tag }}</span><span
                      v-else>{{ p.tagE }}</span></small>
                  <img v-bind:src="picture" class="d-block w-100" :alt="$t('pictureAltRoom')">
                </div>
              </div>
              <button class="carousel-control-prev" type="button"
                      :data-bs-target="carouselTarget(index, 'prev')" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
              </button>
              <button class="carousel-control-next" type="button"
                      :data-bs-target="carouselTarget(index, 'next')" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
              </button>
            </div>
            <div class="link" v-on:click="book(p)">
              <h4 class="poppinsRegular poppinsBold" v-if="p.hasOwnProperty('doubleRoom')"><span
                  v-if="p.doubleRoom">{{ $t('doubleRoom') }}</span><span
                  v-else>{{ $t('singleRoom') }}</span>{{ " - " + p.city }}</h4>
              <h4 class="poppinsRegular" v-else><span v-if="es">{{ p.type }}</span><span
                  v-else>{{ p.typeE }}</span> {{ "- " + p.city }}</h4>
              <h4 class="poppinsRegular">{{ p.address }}</h4>
              <h4 class="poppinsRegular"><span class="poppinsBold">{{ p.price }} €/{{
                  $t('month')
                }} </span><span
                  v-if="p.allBillsIncluded || p.allBillIncluded"> ({{ $t('allIncluded') }})</span></h4>
              <h5 class="poppinsRegular text-primary poppinsItalic" v-if="p.hasOwnProperty('doubleRoom')">
                {{ $t('coliving') }} {{ p.totalRooms }}
                {{ $t('rooms') }}</h5>
              <h5 class="poppinsRegular text-primary" v-else>{{ p.m2 }} m2 - {{ p.rooms }} <span
                  v-if="p.rooms > 1">{{ $t('rooms') }}</span><span
                  v-else>{{ $t('room') }}</span></h5>
            </div>
          </div>
          <div class="col-4 ms-3 mb-3 p-1 space d-flex justify-content-center align-items-center">
            <button class="btn btn-primary btn-plus" v-on:click="seeAll()" v-if="showButtonAll()"
                    v-t="'seeAllRooms'">Ver todos
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-6 mt-0 p-0 text-center">
        <div id="map" style="height: 100%"></div>
      </div>
    </div>
    <div v-if="isSmallScreen" class="flex-fill overflow-auto" id="resultsSearchMobile">
      <div id="mobileList">
        <div class="col m-3 p-2 space" v-for="(p, index) in properties"
             :key="p.id">
          <div :id="'carouselIndicators' + index" class="carousel slide p-3" data-ride="carousel">
            <div class="carousel-inner">
              <div :class="['carousel-item', { active: index === 0 }]" v-for="(picture, index) in p.pictures"
                   v-bind:key="index">
                <small class="floatingNotice" v-if="p.tag">{{ p.tag }}</small>
                <img v-bind:src="picture" class="d-block w-100" :alt="$t('pictureAltRoom')">
              </div>
            </div>
            <button class="carousel-control-prev" type="button"
                    :data-bs-target="carouselTarget(index, 'prev')" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button"
                    :data-bs-target="carouselTarget(index, 'next')" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
          <div v-on:click="book(p)">
            <h4 class="poppinsRegular poppinsBold" v-if="p.hasOwnProperty('doubleRoom')"><span
                v-if="p.doubleRoom">{{ $t('doubleRoom') }}</span><span
                v-else>{{ $t('singleRoom') }}</span>{{ " - " + p.city }}</h4>
            <h4 class="poppinsRegular" v-else>{{ p.type }} {{ "- " + p.city }}</h4>
            <h4 class="poppinsRegular">{{ p.address }}</h4>
            <h4 class="poppinsRegular"><span class="poppinsBold">{{ p.price }} €/{{ $t('month') }} </span><span
                v-if="p.allBillsIncluded || p.allBillIncluded">({{ $t('allIncluded') }})</span></h4>
            <h5 class="poppinsRegular text-primary poppinsItalic" v-if="p.hasOwnProperty('doubleRoom')">
              {{ $t('coliving') }} {{ p.totalRooms }}
              {{ $t('rooms') }}</h5>
            <h5 class="poppinsRegular text-primary" v-else>{{ p.m2 }} m2 - {{ p.rooms }} <span
                v-if="p.rooms > 1">{{ $t('rooms') }}</span><span
                v-else>{{ $t('room') }}</span></h5>
          </div>
        </div>
        <div class="col m-3 p-2 space d-flex justify-content-center align-items-center">
          <button class="btn btn-primary btn-plus" v-on:click="seeAll()" v-if="showButtonAll()"
                  v-t="'seeAllRooms'">Ver todos
          </button>
        </div>
      </div>
      <div id="mobileMap" style="
            position: fixed;
            top: 0;
            left: 0;
            width: 90vw;
            height: 90vh;
            z-index: 9999;
            display: none !important;
            background: #fff;"></div>
    </div>
    <div v-if="isSmallScreen && properties.length > 0" class="floating-icon-list" v-on:click="toggleListMap">
      <i :class="iconListMapClass"></i>
    </div>
    <div v-if="isSmallScreen" class="floating-icon" data-bs-toggle="collapse" href="#collapseSearch" role="button"
         aria-expanded="false" aria-controls="collapseSearch"
         onclick="document.getElementById('check-in-date').focus()">
      <i class="fa fa-search"></i>
    </div>
    <div id="modalError" class="modal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Ooops!</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="card-body">
              <h5>{{ modalError.message }}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <AppFooter/>
</template>

<script>
/* global google */
import AppFooter from "@/components/Footer.vue";
import axios from 'axios';
import $ from "jquery";
import {Collapse, Modal} from 'bootstrap'
import AppMenuItems from "@/components/MenuItems.vue";
import AppLogo from "@/components/Logo.vue";

function sorting(a, b) {
  if (a.priority && !b.priority) {
    return -1;
  } else if (!a.priority && b.priority) {
    return 1;
  }

  if (a.freeOn === 0 && b.freeOn !== 0) {
    return -1;
  } else if (a.freeOn !== 0 && b.freeOn === 0) {
    return 1;
  } else {
    return a.freeOn - b.freeOn;
  }
}

export default {
  name: 'AppFind',
  components: {AppLogo, AppMenuItems, AppFooter},
  el: '#app',
  data() {
    return {
      selectedCity: 'León',
      checkInDate: new Date().toISOString().substr(0, 10),
      checkOutDate: new Date(new Date(new Date().setDate(new Date().getDate() + 7)).getTime() - 24 * 60 * 60 * 1000).toISOString().substr(0, 10),
      numOfPeople: '1',
      minCheckIn: new Date().toISOString().substr(0, 10),
      minCheckOut: new Date(new Date(new Date().setDate(new Date().getDate() + 7)).getTime() - 24 * 60 * 60 * 1000).toISOString().substr(0, 10),
      bookingType: 'apartment',
      properties: [],
      markers: [],
      modalError: {
        instance: null,
        message: ''
      },
      totals: {
        totalA: 10,
        totalR: 10,
      },
      selectedProperty: {},
      map: null,
      iconListMapClass: 'fa fa-map',
      isMobileScreen: window.matchMedia("(max-width: 600px)").matches
    }
  },
  mounted: async function () {
    this.modalError.instance = new Modal(document.getElementById('modalError'), {});
    this.getTotals();
    this.getParams();
    if (!this.isMobileScreen) {
      new Collapse('#collapseSearch', {}).show();
    }
    document.title = this.generateTitle();
    this.setMeta();
  },
  computed: {
    es() {
      return this.$i18n.locale === 'es';
    },
    isSmallScreen() {
      return window.matchMedia("(max-width: 600px)").matches;
    },
    carouselTarget() {
      return (index, slide) => {
        if (slide === 'prev' || slide === 'next') {
          return `#carouselIndicators${index}`;
        } else {
          return `#carouselIndicators${index}`;
        }
      };
    }
  },
  methods: {
    generateMessageMeta: function () {
      if (this.es) {
        if (this.bookingType == 'room') {
          return "Alquila tu habitación en León con Flatprive: estancias flexibles, seguras y con todo incluido. Ideal para estudiantes y jóvenes profesionales. ¡Consulta disponibilidad ahora!"
        } else {
          return "Alquila tu piso en León con Flatprive: alquileres seguros, amueblados y listos para entrar a vivir. Perfectos para profesionales en estancias medias o largas. ¡Consulta disponibilidad hoy!"
        }
      } else {
        if (this.bookingType == 'room') {
          return "Rent your room in León with Flatprive: flexible, secure stays with everything included. Ideal for students and young professionals. Check availability now!"
        } else {
          return "Rent your apartment in León with Flatprive: secure, furnished rentals ready to move in. Perfect for professionals on medium to long stays. Check availability today!"
        }
      }
    },
    setMeta: function () {
      let message = this.generateMessageMeta();
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute("content", message);
      } else {
        const meta = document.createElement('meta');
        meta.name = "description";
        meta.content = message;
        document.head.appendChild(meta);
      }
    },
    generateTitle: function () {
      if (this.bookingType == 'room') {
        return this.es ? 'Alquiler de Habitaciones en León | Flatprive' : 'Room Rental in León | Flatprive';
      } else {
        return this.es ? 'Alquiler de Pisos en León | Flatprive' : 'Apartment Rental in León | Flatprive';
      }
    },
    showModalError: function (message) {
      this.modalError.message = message;
      this.modalError.instance.show();
    },
    getParams: function () {
      const params = new URLSearchParams(window.location.search);
      let showAll = params.get('showAll') || true;
      this.city = params.get('city') || 'León';
      this.checkInDate = new Date(params.get('checkInDate') || new Date()).toISOString().substr(0, 10);
      this.checkOutDate = new Date(params.get('checkOutDate') || new Date(new Date().setDate(new Date().getDate() + 7)).getTime() - 24 * 60 * 60 * 1000).toISOString().substr(0, 10);
      this.people = params.get('people') || '1';
      this.bookingType = params.get('type') || this.checkURLForType()

      if (showAll && this.bookingType) {
        this.getAll(this.bookingType)
      } else {
        this.submitSearchForm();
      }
    },
    checkURLForType: function () {
      if (window.location.href.includes('room') || window.location.href.includes('habitacion')) {
        return 'room';
      } else {
        return 'apartment';
      }
    },
    getTotals: function () {
      axios.get('/search/totals').then(async res => {
        this.totals = res.data
      }).catch(e => {
        console.log('Error getting totals', e);
      })
    },
    submitSearchForm: function () {
      console.log('Looking for possible apartments/rooms...')
      if (!this.validDates()) {
        this.showModalError('¡Has de introducir fechas válidas!');
      } else {
        axios.post('/search', {
          city: this.selectedCity,
          check_in_date: this.checkInDate,
          check_out_date: this.checkOutDate,
          num_of_people: this.numOfPeople,
          booking_type: this.bookingType
        }).then(async res => {
          if (this.isMobileScreen && $("#collapseSearch").hasClass("show")) {
            new Collapse('#collapseSearch', {}).hide();
          }
          this.properties = res.data;
          $("#resultsSearch").fadeIn();
          await this.initMap();
        }).catch(error => {
          console.error(error)
        })
      }
    },
    getAll: function (type) {
      axios.get('/' + type + 's').then(async res => {
        this.properties = res.data.sort((a, b) => sorting(a, b));
        $("#resultsSearch").fadeIn();
        await this.initMap();
      }).catch(e => {
        console.log('Error getting rooms', e);
      })
    },
    validDates: function () {
      if (this.checkInDate && this.checkOutDate) {
        const selectedStartDate = new Date(this.checkInDate);
        const selectedEndDate = new Date(this.checkOutDate);

        return selectedStartDate < selectedEndDate;
      } else {
        return false;
      }
    },
    book: function (p) {
      console.log('Booking property ', p)
      window.open('/' + (this.es ? 'reservar' : 'en/booking') + '?reference=' + p._id + '&checkInDate=' + this.checkInDate + '&checkOutDate=' + this.checkOutDate + '&people=' + this.numOfPeople + '&type=' + this.bookingType, '_blank');
    },
    see: function (p) {
      this.selectedProperty = p;
    },
    updateMax: function () {
      this.minCheckOut = new Date(new Date(new Date(this.checkInDate).setDate(new Date(this.checkInDate).getDate() + 7)).getTime() - 24 * 60 * 60 * 1000).toISOString().split('T')[0];
      if (this.checkOutDate < this.minCheckOut) {
        this.checkOutDate = this.minCheckOut;
      }
    },
    mouseOverMap: function (propertyId) {
      try {
        let markerElement = document.getElementById(this.markers.filter(m => m.propertyId == propertyId)[0].markerId)
        if (markerElement) {
          markerElement.classList.remove('price-tag');
          markerElement.classList.add('price-tagSelected');
        }
      } catch (e) {
        console.error(e);
      }
    },
    mouseOutMap: function (propertyId) {
      try {
        let markerElement = document.getElementById(this.markers.filter(m => m.propertyId == propertyId)[0].markerId)
        if (markerElement) {
          markerElement.classList.remove('price-tagSelected');
          markerElement.classList.add('price-tag');
        }
      } catch (e) {
        console.error(e);
      }
    },
    initMap: async function () {
      const {Map} = await google.maps.importLibrary("maps");
      const {AdvancedMarkerElement} = await google.maps.importLibrary("marker");

      let id = this.isMobileScreen ? 'mobileMap' : 'map';
      const map = new Map(document.getElementById(id), {
        center: {lat: 42.5982503, lng: -5.5720172},
        zoom: 14,
        mapId: 'fa321853204c345f'
      });

      this.map = map;

      for (let i = 0; i < this.properties.length; i++) {
        let property = this.properties[i];

        const priceTag = document.createElement("div");
        const uniqueId = "id-" + i;
        priceTag.className = "price-tag";
        priceTag.textContent = property.price + " €";
        priceTag.id = uniqueId

        let marker = new AdvancedMarkerElement({
          map,
          position: {lat: property.latitude, lng: property.longitude},
          content: priceTag
        });

        this.markers.push({
              propertyId: property._id,
              marker: marker,
              markerId: uniqueId
            }
        );

        marker.addListener("click", () => {
          this.map.setCenter({lat: property.latitude, lng: property.longitude});
          this.book(this.properties.filter(p => p._id == property._id)[0]);
        });
      }
    },
    toggleListMap: function () {
      if (this.iconListMapClass == 'fa fa-list') {
        this.iconListMapClass = 'fa fa-map';
        $("#mobileMap").fadeOut();
        $("#mobileList").fadeIn();
      } else {
        this.iconListMapClass = 'fa fa-list';
        $("#mobileList").fadeOut();
        $("#mobileMap").fadeIn();
      }
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    seeAll: function () {
      this.getAll(this.bookingType);
    },
    showButtonAll: function () {
      if (this.bookingType == 'apartment') {
        return this.properties.length < this.totals.totalA;
      } else {
        return this.properties.length < this.totals.totalR;
      }
    }
  }
}
</script>

<style scoped src="../assets/css/find.css"></style>
<style scoped>
:deep(.nav-link) {
  color: #264464 !important;
  font-family: "Poppins", sans-serif;
  font-size: 18px;
  font-weight: 400;
}
</style>